import Auth from './Auth'
import { getDefaultRoute } from '../common/routerUtils'
import { pinia } from '@/store/createPinia'
import { useShellStore } from '@/store'
const auth = new Auth()

export default (router) => {
  const openAgreement = (to) => {
    let plan = to.meta.plan
    if (!plan || plan.extUrl || plan.tfId || !plan.id) {
      plan = {
        ...plan,
        id: to.meta.token_type === 'farmapremium'
          ? 'status'
          : 'prices'
      }
    }
    const shellStore = useShellStore(pinia)
    shellStore.SET_AGREEMENT_PROPS({ modelValue: true, plan })
  }
  return async (to, from) => {
    try {
      const requireAuth = to.matched.some(record => record.meta.requireAuth)
      const isNewEnter = from.name == null
      const isActive = to.meta.active !== false
      if (requireAuth) {
        if (isNewEnter) {
          const nextTo = auth.loadNextTo()
          if (nextTo) {
            window.history.pushState({ }, '', nextTo.to.path)
            return nextTo.to.path
          }
        }
        if (to.name === 'root-child' || (isNewEnter && !isActive)) {
          const defaultRoute = getDefaultRoute(router)
          !isActive && openAgreement(to)
          return { name: defaultRoute.name }
        }
        if (!isActive) {
          openAgreement(to)
          return false
        }
      }
    } catch (err) {
      console.error(err)
      return false
    }
  }
}
